import React, { Component } from 'react'
import { PUBLIC_IMG_URL } from '../../lib/endpoints'
import { withBootstrapPlugin } from '../../lib/helpers'

class SuccessPopup extends Component {

    render() {

        const { msg, isGoogleAdsConversionMetric } = this.props;

        if (!msg) {
            return null;
        }

        return (
            <div>
                {/* 
                  * Google Ads conversion is based on the following element selector:
                  * #successModal.google-ads-conversion-form.show 
                  * we must use 'show' so that conversion is only achieved when the modal is displayed. this is because the modal is always present on the page
                  */}
                <div className={`modal fade pr-0 ${isGoogleAdsConversionMetric ? 'google-ads-conversion-form' : ''}`} id="successModal">
                    <div className="modal-dialog feedback-modal">
                        <div className="modal-content">

                            <div className="modal-body" style={{ background: '#e5e6e8' }}>
                                <div className="content" style={{ padding: '20px 0' }}>

                                    <div className="text-center">
                                        <a type="button"
                                            className="close"
                                            onClick={() => {
                                                this.props.handleClose();
                                                withBootstrapPlugin('modal', ($) => {
                                                    $('.modal').modal('hide');
                                                    $('.modal-backdrop').remove();
                                                });
                                            }}
                                            data-dismiss="modal">&times;</a>
                                        <img src={`${PUBLIC_IMG_URL}/icons/success.png`} alt="success" />
                                        <h3>Congratulations!</h3>
                                        <p className="mt-4">
                                            {msg}
                                            {this.props.isPartial && 
                                                <>However, the operation was completed with the following errors: </>
                                            }
                                            {this.props.isPartial && this.props.errors.map(error => 
                                                <p className="mt-3">{error}</p>
                                            )}
                                        </p>

                                        {/* optional, add an action button, e.g. go to profile after editing
                                            use these props:
                                            showButton, buttonText, buttonAction => ...
                                        */}
                                        {(!this.props.isPartial && this.props.showButton) &&
                                            <a className="btn btn-main btn-sm mt-4" onClick={() => this.props.buttonAction()}>
                                                {this.props.buttonText}
                                            </a>
                                        }
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default SuccessPopup